import { render, staticRenderFns } from "./ValidMsg.vue?vue&type=template&id=b16f4fc2&scoped=true"
import script from "./ValidMsg.vue?vue&type=script&lang=js"
export * from "./ValidMsg.vue?vue&type=script&lang=js"
import style0 from "./ValidMsg.vue?vue&type=style&index=0&id=b16f4fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16f4fc2",
  null
  
)

export default component.exports